<!-- Content page started -->
<div class="row">
  <div class="col-md-12">
    <div class="page-breadcrumb">
      <ul class="page-breadcrumb__trail">
        <li><a>Dashboard</a></li>
      </ul>
    </div>
  </div>
</div>

<div class="row provider-dashboard">

  <div class="page-title-container">
    <h1 class="page-title">Admin Configuration</h1>
    <p class="page-subtitle">Manage system masters and settings</p>
  </div>

  <!-- USER SETTINGS -->
  <div class="dashboard-section">
    <div class="section-header">User Settings</div>

    <div class="card-container">
      <div class="card" routerLink="/home/routes">
        <span class="card-title">Routes</span>
        <span class="card-subtitle">Manage routes</span>
      </div>

      <div class="card" routerLink="/home/feature">
        <span class="card-title">Features</span>
        <span class="card-subtitle">Application features</span>
      </div>

      <div class="card" routerLink="/home/screen">
        <span class="card-title">Screens</span>
        <span class="card-subtitle">UI screens</span>
      </div>

      <div class="card" routerLink="/home/businesscategory">
        <span class="card-title">Business Categories</span>
        <span class="card-subtitle">Category master</span>
      </div>

      <div class="card" routerLink="/home/businesstype">
        <span class="card-title">Business Types</span>
        <span class="card-subtitle">Type master</span>
      </div>

      <div class="card" routerLink="/home/personrole">
        <span class="card-title">Person Roles</span>
        <span class="card-subtitle">Role mapping</span>
      </div>

      <div class="card" routerLink="/home/aclsync">
        <span class="card-title">ACL Sync</span>
        <span class="card-subtitle">Access control</span>
      </div>
    </div>
  </div>

  <!-- MATERIAL -->
  <div class="dashboard-section">
    <div class="section-header">Material</div>

    <div class="card-container">
      <div class="card" routerLink="/home/transactiontype">
        <span class="card-title">Transaction Types</span>
        <span class="card-subtitle">Transactions classification</span>
      </div>

      <div class="card" routerLink="/home/uom">
        <span class="card-title">Units of Measurement</span>
        <span class="card-subtitle">Measurement units</span>
      </div>

      <div class="card" routerLink="/home/shapes">
        <span class="card-title">Shapes</span>
        <span class="card-subtitle">Material shapes</span>
      </div>

      <div class="card" routerLink="/home/itemtype">
        <span class="card-title">Item Types</span>
        <span class="card-subtitle">Item classification</span>
      </div>
    </div>
  </div>

  <!-- AQUA CULTURE -->
  <div class="dashboard-section">
    <div class="section-header">Aqua Culture</div>

    <div class="card-container">
      <div class="card" routerLink="/home/culturecategory">
        <span class="card-title">Culture Categories</span>
        <span class="card-subtitle">Culture master</span>
      </div>

      <div class="card" routerLink="/home/watertype">
        <span class="card-title">Water Types</span>
        <span class="card-subtitle">Water classification</span>
      </div>

      <div class="card" routerLink="/home/soiltype">
        <span class="card-title">Soil Types</span>
        <span class="card-subtitle">Soil classification</span>
      </div>

       <div class="card" routerLink="/home/speciestype">
        <span class="card-title">Species Types</span>
        <span class="card-subtitle">Species master</span>
      </div>
      
       <div class="card" routerLink="/home/activitieslist">
        <span class="card-title">Activity Types</span>
        <span class="card-subtitle">Activities classification</span>
      </div>

        <div class="card" routerLink="/home/broodbreederslist">
        <span class="card-title">Brood Breeders</span>
        <span class="card-subtitle">Brood Breeders classification</span>
      </div>

      <div class="card" routerLink="/home/broodlineslist">
        <span class="card-title">Brood Lines</span>
        <span class="card-subtitle">Brood Lines classification</span>
      </div>
      
      <div class="card" routerLink="/home/observationtypeslist">
        <span class="card-title">Observation Types</span>
        <span class="card-subtitle">Observation classification</span>
      </div>

      <div class="card" routerLink="/home/treatmenttypeslist">
        <span class="card-title">Treatment Types</span>
        <span class="card-subtitle">Treatment classification</span>
      </div>

      <div class="card" routerLink="/home/pondtypeslist">
        <span class="card-title">Pond Types</span>
        <span class="card-subtitle">Pond Types classification</span>
      </div>

      <div class="card" routerLink="/home/pondusageslist">
        <span class="card-title">Pond Usages</span>
        <span class="card-subtitle">Pond Usages classification</span>
      </div>
    </div>
  </div>
</div>